(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["attracione-search"] && !Shopify.designMode) return;
  try {
    const initializeAttracioneSearch = () => {
    const root = document.querySelector('[data-attracione-search]');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const dialog = root.querySelector('[data-search-dialog]');
    const form = root.querySelector('.attracione-search__form');
    const input = root.querySelector('input[type="search"]');
    const predictive = root.querySelector('[data-search-predictive]');
    const loadingText = root.dataset.searchLoading;
    const errorText = root.dataset.searchError;
    let lastTrigger;
    let previousOverflow = '';
    let debounceTimer;
    let requestController;

    const openDialog = (trigger) => {
      lastTrigger = trigger;
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      if (!dialog.open) dialog.showModal();
      input.focus();
    };

    const closeDialog = () => {
      if (dialog.open) dialog.close();
    };

    const clearPredictive = () => {
      window.clearTimeout(debounceTimer);
      requestController?.abort();
      requestController = undefined;
      predictive.replaceChildren();
      predictive.removeAttribute('aria-busy');
      input.setAttribute('aria-expanded', 'false');
    };

    const renderStatus = (message, modifier) => {
      const status = document.createElement('p');
      status.className = `attracione-search__no-results attracione-search__no-results--${modifier}`;
      status.setAttribute('role', 'status');
      status.textContent = message;
      predictive.replaceChildren(status);
      input.setAttribute('aria-expanded', 'true');
    };

    const renderPredictive = async (term) => {
      requestController?.abort();
      const currentController = new AbortController();
      requestController = currentController;
      predictive.setAttribute('aria-busy', 'true');
      renderStatus(loadingText, 'loading');

      const baseUrl = window.routes?.predictive_search_url || '/search/suggest';
      const parameters = new URLSearchParams({
        q: term,
        'resources[type]': 'product',
        'resources[limit]': '6',
        'resources[options][unavailable_products]': 'hide',
        section_id: 'attracione-predictive-search',
      });

      try {
        const response = await fetch(`${baseUrl}?${parameters}`, {
          signal: currentController.signal,
          headers: { Accept: 'text/html' },
        });
        if (!response.ok) throw new Error(`Predictive search ${response.status}`);

        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = documentFragment.querySelector('[data-attracione-predictive-content]');
        if (input.value.trim() !== term || !content) return;

        predictive.replaceChildren(...Array.from(content.childNodes));
        input.setAttribute('aria-expanded', predictive.childElementCount > 0 ? 'true' : 'false');
      } catch (error) {
        if (error.name !== 'AbortError' && input.value.trim() === term) {
          renderStatus(errorText, 'error');
        }
      } finally {
        if (requestController === currentController) {
          requestController = undefined;
          predictive.removeAttribute('aria-busy');
        }
      }
    };

    input.addEventListener('input', () => {
      const term = input.value.trim();
      window.clearTimeout(debounceTimer);
      requestController?.abort();

      if (!term) {
        clearPredictive();
        return;
      }

      debounceTimer = window.setTimeout(() => renderPredictive(term), 220);
    });

    input.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowDown') return;
      const firstResult = predictive.querySelector('a');
      if (!firstResult) return;
      event.preventDefault();
      firstResult.focus();
    });

    predictive.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      const results = Array.from(predictive.querySelectorAll('a'));
      const currentIndex = results.indexOf(document.activeElement);
      if (currentIndex < 0) return;
      event.preventDefault();
      const nextIndex = event.key === 'ArrowDown' ? currentIndex + 1 : currentIndex - 1;
      if (nextIndex < 0) input.focus();
      else results[Math.min(nextIndex, results.length - 1)].focus();
    });

    form.addEventListener('submit', (event) => {
      const term = input.value.trim();
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!term) return;
      window.clearTimeout(debounceTimer);
      renderPredictive(term);
    }, true);

    document.addEventListener('click', (event) => {
      const trigger = event.target instanceof Element
        ? event.target.closest('[data-attracione-search-trigger]')
        : null;
      if (trigger) openDialog(trigger);
    });

    root.querySelector('[data-search-close]').addEventListener('click', closeDialog);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDialog();
    });
    dialog.addEventListener('close', () => {
      clearPredictive();
      document.body.style.overflow = previousOverflow;
      lastTrigger?.focus();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAttracioneSearch, { once: true });
  } else {
    initializeAttracioneSearch();
  }
  } catch(e) { console.error(e); }
})();

})();
